import {Injectable} from '@angular/core';
import {CrudAction, CrudService, ErrorNotification, Notification, RequestParams, SuccessNotification} from '@ngx-ivengi/crud';
import {Observable} from 'rxjs/Observable';
import {ChannelService} from '../channel/channel.service';
import {Datagrid} from './datagrid.model';
import {FloorService} from '../floor/floor.service';
import {OwnerService} from '../owner/owner.service';
import {CustomerService} from '../customer/customer.service';
import {BuildingService} from '../building/building.service';
import {RoomService} from '../room/room.service';
import {UserService} from '../user/user.service';
import {EnumerationService} from '../enumeration/enumeration.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import {CrudInteractionService} from '@ngx-ivengi/crud';
import {CrudConfig} from '@ngx-ivengi/crud';

@Injectable()
export class DatagridService extends CrudService<Datagrid> {
  public entityType = Datagrid;
  private channelIdsOfPage: string[] = [];

  constructor(
    config: CrudConfig, http: HttpClient, interactionService: CrudInteractionService,
    private ownerService: OwnerService,
    private customerService: CustomerService,
    private channelService: ChannelService,
    private buildingService: BuildingService,
    private floorService: FloorService,
    private roomService: RoomService,
    private userService: UserService,
    private enumerationService: EnumerationService
  ) {
    super(config, http, interactionService);
  }

  public getAll(requestParams: RequestParams = null): Observable<Datagrid[]> {

    return new Observable((observer) => {
      let httpParams = new HttpParams();

      if(requestParams) {
        const params = requestParams.toKeyValueParams();
        for(const key in params) {
          if(params[key]) {
            httpParams = httpParams.append(key, params[key]);
          }
        }
      }

      this.http.get(`${this.getBaseUrl()}`, {params: httpParams, observe: 'response'}).map((response: any) => {
        if(response.body && response.body.items.length > 0) {
          response.body.items = response.body.items.map((data) => {
            const oEntity = new this.entityType();
            oEntity.fromResponse(data);
            return oEntity;
          });

          if(requestParams) {
            requestParams.pagination.count  = response.body.meta.count;
          }
        }

        return response;
      }).subscribe(
        response => {
          this.interactionService.notify(
            <Notification>new SuccessNotification()
              .setEntity(<any>this.entityType)
              .setAction(CrudAction.LIST)
              .setHttpCode(response.status)
              .setData(response.body.items)
          );

          this.channelIdsOfPage = (typeof response.body.meta.channelIds !== 'undefined') ? response.body.meta.channelIds : [];
          observer.next(response.body.items);
        },
        err => {

          let error;
          try {
            error = JSON.parse(err.error);
          } catch(e) {
            error = err.error;
          }

          this.interactionService.notify(
            <Notification>new ErrorNotification()
              .setEntity(<any>this.entityType)
              .setAction(CrudAction.LIST)
              .setHttpCode(err.status)
              .setData(error)
          );

          observer.error(err);
        }
      );
    });
  }

  public getChannelIdsOfPage(): string[] {
    return this.channelIdsOfPage;
  }

  public getFilterOptionsForClient() {
    return this.http.get(`${this.getBaseUrl()}/filter-data`);
  }

  public getOwnerService() {
    return this.ownerService;
  }

  public getCustomerService() {
    return this.customerService;
  }

  public getChannelService() {
    return this.channelService;
  }

  public getBuildingService() {
    return this.buildingService;
  }

  public getFloorService() {
    return this.floorService;
  }

  public getRoomService() {
    return this.roomService;
  }

  public getUserService() {
    return this.userService;
  }

  public getEnumerationService() {
    return this.enumerationService;
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/datagrid/datagrid.service.ts